import { css, FlattenSimpleInterpolation } from 'styled-components';


export type Adaptive = {
	fullWidth?: boolean;
}

export type MediaRules = Array<{
	type: 'max-width'| 'min-width' | 'max-height' | 'min-height',
	size: number;
	unit: 'px';
	css: FlattenSimpleInterpolation;
}>;

const makeFullWidth = (p: Adaptive) => css`
	width: ${p.fullWidth ? '100%' : 'auto'};
`;

const makeMedia = (rules: MediaRules) => {
	if (!rules || rules.length === 0) return '';

	const str = rules.reduce((acc, v) => {
		acc += `
			@media(${v.type}: ${v.size}${v.unit}) {
				${v.css}
			}
		`;

		return acc;
	}, '');

	return str;
};

export {
	makeFullWidth,
	makeMedia,
}